module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section about-team"
  }, [_c('div', {
    staticClass: "section__container about-team__container"
  }, [_c('div', {
    staticClass: "section__header about-team__header"
  }, [_c('div', {
    staticClass: "section__header-title about-team__header-title"
  }, [_vm._v(_vm._s(_vm.content.team.title))]), _c('div', {
    staticClass: "section__header-subtitle about-team__header-subtitle"
  }, [_vm._v(_vm._s(_vm.content.team.subtitle))])]), _c('div', {
    staticClass: "about-team__video",
    style: ({
      backgroundImage: "url(" + _vm.content.team.poster + ")"
    })
  }, [_c('div', {
    staticClass: "about-team__video-play",
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "video-play"
    }
  })], 1)])]), (_vm.showModal) ? _c('TeamModal', {
    attrs: {
      "content": _vm.content
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ccbb0a3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-team/custom-team.pug
// module id = 499
// module chunks = 1